export default __webpack_public_path__ + "box-top-fix.jpg";